export enum UserVerificationStatusField {
  userStatus = 'userStatus',
  userAccess = 'userAccess',
  primaryCardInfo = 'primaryCardInfo',
  cardMailedDate = 'cardMailedDate',
  cardStatus = 'cardStatus',
  replacementInitiation = 'replacementInitiation',
}
